// Default select with no search
$('.__select select').each(function () {
    $(this).select2({
        containerCssClass: 'select2-css',
        minimumResultsForSearch: Infinity,
    })
});